import React, { useEffect, useState } from "react";
import { Box, Heading, Button } from "@chakra-ui/react";
import { useNavigate , useLocation} from "react-router-dom";

const EmailPreview: React.FC = () => {
  const [emailHtml, setEmailHtml] = useState<string>("");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if(location.state?.html){
      setEmailHtml(location.state.html)
    }
    
  }, []);

  return (
    <Box p={4}>
      <Heading size="md" mb={4}>
        Email Preview
      </Heading>

      {/* Preview the email */}
      <Box
        border="1px solid #ccc"
        borderRadius="md"
        p={4}
        minH="400px"
        dangerouslySetInnerHTML={{ __html: emailHtml }}
      />

      <Button
        mt={4}
        colorScheme="blue"
        onClick={() => navigate("/email-editor")}
      >
        Back to Editor
      </Button>
    </Box>
  );
};

export default EmailPreview;
